// Cart Items Card Interactions
document.addEventListener('DOMContentLoaded', function() {
  
  // Quantity Selector Buttons
  const quantityButtons = document.querySelectorAll('.quantity-selector__btn');
  const quantityInputs = document.querySelectorAll('.quantity-selector__input');

  quantityButtons.forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      
      const action = this.getAttribute('data-action');
      const parentContainer = this.closest('.quantity-selector');
      const input = parentContainer.querySelector('.quantity-selector__input');
      
      let currentValue = parseInt(input.value) || 0;
      const minValue = parseInt(input.getAttribute('min')) || 0;
      
      if (action === 'increase') {
        currentValue += 1;
      } else if (action === 'decrease' && currentValue > minValue) {
        currentValue -= 1;
      }
      
      input.value = currentValue;
      updateCartItemQuantity(input);
    });
  });

  // Direct Input Change
  quantityInputs.forEach(input => {
    input.addEventListener('change', function(e) {
      let value = parseInt(this.value) || 0;
      const minValue = parseInt(this.getAttribute('min')) || 0;
      
      if (value < minValue) {
        value = minValue;
        this.value = value;
      }
      
      updateCartItemQuantity(this);
    });

    // Prevent non-numeric input
    input.addEventListener('keypress', function(e) {
      if (!/[0-9]/.test(e.key)) {
        e.preventDefault();
      }
    });
  });

  // Update Cart Item Quantity
  function updateCartItemQuantity(input) {
    const variantId = input.getAttribute('data-quantity-variant-id');
    const quantity = parseInt(input.value) || 0;

    if (!variantId) return;

    // Show loading state
    input.disabled = true;
    const card = input.closest('.cart-item-card');
    if (card) {
      card.style.opacity = '0.6';
    }

    // Send update to server
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        updates: {
          [variantId]: quantity
        }
      })
    })
    .then(response => response.json())
    .then(data => {
      // Refresh the entire cart page to reflect changes
      location.reload();
    })
    .catch(error => {
      console.error('Error updating cart:', error);
      if (card) {
        card.style.opacity = '1';
      }
      input.disabled = false;
      alert('Error updating cart. Please try again.');
    });
  }

  // Remove Button Handler
  const removeButtons = document.querySelectorAll('.cart-item-card__remove-btn');
  removeButtons.forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      
      if (confirm('Are you sure you want to remove this item?')) {
        const url = this.getAttribute('href');
        location.href = url;
      }
    });
  });

  // Cart Refresh Handler (from other sections)
  document.addEventListener('cart:refresh', function() {
    location.reload();
  });
});

// Custom Cart Update Handler
window.CartItemsCard = {
  updateQuantity: function(variantId, quantity) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        updates: {
          [variantId]: quantity
        }
      })
    })
    .then(response => response.json())
    .then(() => {
      // Dispatch custom event for other sections to listen
      document.dispatchEvent(new CustomEvent('cart:updated'));
    });
  },

  removeItem: function(variantId) {
    window.CartItemsCard.updateQuantity(variantId, 0);
  }
};